import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Typography, Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#0369a1", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#e0f2fe", border: "1px solid #bae6fd", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#0c4a6e", lineHeight: 1.6 },
  warnBox: { background: "#fff7ed", border: "1px solid #fed7aa", borderRadius: 8, padding: theme.spacing(1.5), marginTop: theme.spacing(1.5) },
  warnText: { fontSize: "0.8rem", color: "#9a3412" },
}));

const DEFAULT = { contratoVar: "sgp_contrato_id" };

const FlowBuilderSgpDesbloqueioModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ contratoVar: data.data.data.contratoVar || "sgp_contrato_id" });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    if (open === "edit") {
      onUpdate(data.id, { data: { label: `Desbloqueio {{${cfg.contratoVar}}}`, data: cfg } });
    } else {
      onSave({ label: `Desbloqueio {{${cfg.contratoVar}}}`, data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>SGP — Desbloqueio de Confiança</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Realiza o desbloqueio de acesso do contrato (promessa de pagamento).
            O token SGP precisa ter permissão de liberação.
          </Typography>
        </Box>

        <TextField
          label="Variável com ID do contrato"
          value={cfg.contratoVar}
          onChange={(e) => setCfg({ ...cfg, contratoVar: e.target.value })}
          fullWidth margin="dense" variant="outlined"
          helperText="Nome da variável com o ID do contrato. Padrão: sgp_contrato_id"
        />

        <Box className={classes.warnBox}>
          <Typography className={classes.warnText}>
            ⚠️ Esta ação libera o acesso do cliente imediatamente — confirme antes de usar em produção.
            O débito continua existindo após o desbloqueio.
          </Typography>
        </Box>

        <Box style={{ marginTop: 12, padding: 12, background: "#f0f9ff", borderRadius: 8, border: "1px solid #bae6fd" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#0c4a6e", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#0369a1" }}>
            🟢 <strong>liberado</strong> — acesso desbloqueado com sucesso<br />
            🔴 <strong>erro</strong> — falha ou sem permissão no token
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderSgpDesbloqueioModal;
